import React, { Component } from 'react';
import moment from 'moment';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import { RouteComponentProps } from '@reach/router';
import { Title } from 'bloomer/lib/elements/Title';
import api from '../util/api';
import AnimalEditableEnrichment from '../components/AnimalEditableEnrichment';
import { popupErrorFromServer } from '../util/helperFunctions';

interface Params {}

interface PropTypes extends RouteComponentProps<Params> {}
interface StateTypes {
  enrichments: { [anumber: string]: Enrichment[] };
}
class EditEnrichments extends Component<PropTypes, StateTypes> {
  state: StateTypes = {
    enrichments: {},
  };

  refresh = async () => {
    try {
      const enrichments = await api.enrichmentData.get({
        startDate: moment()
          .startOf('day')
          .toISOString(),
        endDate: moment()
          .endOf('day')
          .toISOString(),
      });

      const indexedEnrichments: {
        [anumber: string]: Enrichment[];
      } = enrichments.reduce((obj: { [anumber: string]: Enrichment[] }, enrich) => {
        if (obj[enrich.aNumber]) {
          obj[enrich.aNumber].push(enrich);
          return {
            ...obj,
          };
        }

        return {
          ...obj,
          [enrich.aNumber]: [enrich],
        };
      }, {});

      this.setState({
        enrichments: indexedEnrichments,
      });
    } catch (err) {
      popupErrorFromServer(err);
    }
  };

  componentDidMount() {
    this.refresh();
  }

  render() {
    const { enrichments } = this.state;
    const enrichmentArr = Object.entries(enrichments);
    return (
      <Container>
        <Box>
          <Title>Edit Today's Enrichments</Title>
          {enrichmentArr.map(([anumber, enrichments]) => (
            <AnimalEditableEnrichment
              key={`enrich-${anumber}`}
              aNumber={anumber}
              enrichmentData={enrichments}
              refresh={this.refresh}
            />
          ))}
        </Box>
      </Container>
    );
  }
}

export default EditEnrichments;
